const content = {
  root: {
    backText: "Back",
    heading: "You have a great choice",
    viewBenefitText: "View Benefits",
    changeCard_container: {
      label: "Change Card",
      URL: "/en/eapply.page",
    },
    help_container: {
      label: "Help",
      URL: "/en/help.page",
    },
    personalDetails: {
      label: "01 Personal Details",
      heading: {
        text: "Nice Meeting You!",
        subtext:
          "Please enter details as per your KYC records, to match it perfectly",
      },
      name_container: {
        label: "My good name is",
        helpText: "",
        firstName: {
          label: "First Name",
          errorMsg: [
            "Please enter your valid name",
            "Only Alphabets allowed.",
            "Last Name should not be same as First Name",
          ],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "12",
          },
        },
        middleName: {
          label: "Middle Name",
          errorMsg: ["Please enter your valid name", "Only Alphabets allowed."],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "10",
          },
        },
        lastName: {
          label: "Last Name",
          errorMsg: [
            "Please enter your valid name",
            "Only Alphabets allowed.",
            "Last Name should not be same as First Name",
          ],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "16",
          },
        },
        mobileNo: {
          label: "My mobile number is",
          errorMsg: [
            "Only Numbers allowed.",
            "Should have 10 digits. Invalid phone no.",
            "Mobile number should not start with 0",
            "Error sending OTP",
          ],
          validation: {
            validationType: "Number",
            minLength: "10",
            maxLength: "10",
          },
        },
        DOB: {
          min: 18,
          max: 99,
        },
        OTP: {
          label: "OtpInput",
          errorMsg: ["Please enter valid OTP.", "Error Validating OTP"],
          validation: {
            validationType: "Number",
          },
        },
        ResiCity: {
          label: "CityName",
          errorMsg: ["Please select city", "Error saving city"],
          validation: {
            validationType: "Text",
            minLength: "0",
            maxLength: "20",
          },
        },
        PanNumber: {
          label: "PanNumber",
          errorMsg: ["Please enter a Valid Pan Number"],
          validation: {
            validationType: "pan",
            minLength: 1,
            maxLength: 10,
          },
        },
      },
    },
    professionalDetails: {
      label: "02 Professional Details",
      heading: {
        text: "",
        subtext: "",
      },
      name_container: {
        label: "",
        helpText: "",
        addressLine1: {
          label: "Address Line 1",
          errorMsg: ["Please enter valid address line1."],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "40",
          },
        },
        addressLine2: {
          label: "Address Line 2",
          errorMsg: ["Please enter valid address line2."],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "40",
          },
        },
        landmark: {
          label: "Landmark",
          errorMsg: ["Please enter valid address landmark."],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "40",
          },
        },
        pinCode: {
          label: "Pincode",
          errorMsg: [
            "Only numeric value allowed",
            "Please enter valid pin code.",
            "We do not provide services at your pin code.",
          ],
          validation: {
            validationType: "Text",
            minLength: "2",
            maxLength: "40",
          },
        },
      },
    },
  },
  leftSection_container: {
    "heading": "You have a great choice!",
    "changeCard_container": {
      "change_card_page": {
        "cancelTxt": "Cancel",
        "heading": "Dear {name},<br />looks like you want to change your card",
        "footnoteMsg": "If you do not find your desired card, you can still continue with your previous card by clicking 'Resume Now' in the footer of SBI Card website",
        "subheading": "You will go back to SBI Card website, to select another card. Once you click \"Apply\", you can come back here and resume your application process.",
        "redirection": {
          "changeCardBtn": "Change Card",
          "URL": "/en/eapply.page"
        }
      },
      "label": "Change Card",
      "retrieve_card": {
        "cancelTxt": "Continue with existing card",
        "changeCardBtn": "Yes, change my card",
        "heading": "Dear {name}, earlier you had applied for {cardname}",
        "subheading": "Looks like you have selected a different card this time. Kindly confirm that you want to change it to {secondcardname}"
      }
    },
    "viewBenefitText": "View Benefits",
    "retrieveApplicationText": "Retrieve my application"
  },
  process_error: {
    "heading": "Dear {name}, thank you for your request",
    "applicationNumber": "Your application number is {applicationnumber}",
    "footnoteMsg": "You can also track your application status using the application number on www.sbicard.com",
    "trackApplication": "Track Application",
    "information": "We are now validating your application and will update you through SMS, post approval",
    "subheading": "Currently we are unable to process your request"
  },
  card_resume: {
    "heading": "We saved your details last time",
    "subheading": "Resume now with professional details"
  },
  help_contents: {
    "help_topic": [
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I get an plastic delivered?",
            "answer": "Test"
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "Test"
          },
          {
            "question": "Will I get an instant card?",
            "answer": "Test"
          },
          {
            "question": "Will I get an plastic delivered?",
            "answer": "Test"
          }
        ],
        "topic": "Guide to instant card",
        "id": "guideToInstantCardhelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Personal details",
        "id": "personalDetailshelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Professional details",
        "id": "professionalDetailshelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "KYC verification",
        "id": "kycVerificationhelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Bank verification",
        "id": "bankVerificationhelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Instant e-card usage",
        "id": "instantECardUsagehelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Card activation",
        "id": "cardActivationhelp"
      },
      {
        "questions": [
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          },
          {
            "question": "Will I always get an instant card?",
            "answer": "If your application has been approved online, our executives will contact you within 2 working days to inform you about the documents you need to submit. They will also set an appointment with you to collect the necessary documents from you. Once you have submitted your documents, it will take us up to 21 days to process your application. Final approval of your credit card depends on the documents, you provide to us.<br /><br />If you wish to appply for an additional SBI Card, you can select 'Yes' for the 'Do you have an SBI Card' question on the online application form for the SBI Card you wish to apply for and fill in the required details."
          }
        ],
        "topic": "Add-on benefits",
        "id": "addOnBenefitshelp"
      }
    ],
    "heading": "All topics",
    "label": "Help Center"
  },
  pennydrop_container: {
    "landing_screen": {
      "step_two": {
        "heading": "Debit",
        "count": 2,
        "label": "STEP",
        "subheading": "We would request you to pay back <b>{Rs} 1.00</b> to us"
      },
      "footnoteMsg": "(The above credit and debit steps are mandatory and should happen from the same bank account)",
      "step_one": {
        "heading": "Credit",
        "count": 1,
        "label": "STEP",
        "subheading": "We will first transfer <b>{Rs} 1.00</b> to your bank account"
      },
      "subheading": "This will be a 2 step process:",
      "continueButton": "Start with step 1"
    },
    "payment_modes": {
      "netBanking": "Net Banking",
      "payment_failure": {
        "retryButton": "Retry payment",
        "mainText": "Transaction failed",
        "transactionInfo": "Your Transaction ID is {transactionid}"
      },
      "failure_exit": {
        "exitButton": "Exit apply journey",
        "heading": "Dear {name}, this will pause your apply journey",
        "retryButton": "Retry payment",
        "subheading": "You are just 1 step away from getting your card. We would request you to complete your transaction"
      },
      "footnoteMsg": "If you chose to use UPI to complete payment of {Rs} 1.00, then your UPI ID must be of <b> {bankname}</b>",
      "subheading": "Select from the below modes to pay <b>{Rs} 1.00</b>",
      "payment_successful": {
        "mainText": "Payment successful",
        "continueButton": "Continue",
        "transactionInfo": "Your transaction ID is {transactionid}"
      },
      "upi": "UPI"
    },
    "heading": "Bank verification for KYC",
    "bank_details": {
      "account_number": {
        "helpText": "",
        "label": "Account number",
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid account number",
              "id": "invalidAccNo"
            },
            {
              "msg": "Enter exactly same account number",
              "id": "lengthcheck"
            }
          ]
        }
      },
      "reenter_account_number": {
        "helpText": "",
        "label": "Re-enter account number",
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "footnoteMsg": "We will now credit <b>{Rs} 1.00</b> in your bank account mentioned above",
      "bank_name": {
        "helpText": "",
        "label": "Bank name",
        "text": "Name",
        "validation": {
          "validationType": "text",
          "minLength": "",
          "maxLength": ""
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please select from list",
              "id": "namenotexist"
            }
          ]
        }
      },
      "subheading": "To verify bank details we will transfer <b>{Rs} 1.00</b> to your bank account",
      "IFSCText": "Search for IFSC",
      "continueButton": "Continue to accept {Rs} 1",
      "IFSC": {
        "helpText": "",
        "label": "IFSC code",
        "text": "Code",
        "validation": {
          "validationType": "text",
          "minLength": "",
          "maxLength": ""
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid IFSC Code",
              "id": "formatcheck"
            },
            {
              "msg": "Please enter IFSC code",
              "id": "focusout"
            }
          ]
        }
      }
    },
    "label": "03 KYC Details - Bank Verification",
    "find_IFSC": {
      "bank_branch": {
        "helpText": "",
        "label": "Bank Branch",
        "text": "Branch Name",
        "validation": {
          "validationType": "text",
          "minLength": "",
          "maxLength": ""
        },
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "backToBank": "Back to bank information",
      "cityName": "City Name",
      "heading": "Find IFSC",
      "IFSCCode": "IFSC code",
      "bankName": "Bank name",
      "continueButton": "Continue"
    },
    "credit_complete": {
      "footnoteMsg": "We will now debit <b>{Rs} 1.00</b> from the same bank account to complete the process",
      "mainText": "Your step 1 is complete now",
      "subheading": "We have credited <b>{Rs} 1.00</b> to your bank account",
      "continueButton": "Continue to pay {Rs} 1"
    }
  },
  leftsection_details: {
    "heading": "Dear {name},<br />Welcome back",
    "subheading": "You are applying for the below card"
  },
  footer_container: {
    "cardHolder_container": {
      "label": "Cardholder Agreement",
      "URL": "/en/eapply.page"
    },
    "copyrightLabel": "©SBI Card 2022",
    "privacy_container": {
      "label": "Privacy Policy",
      "URL": "/en/help.page"
    },
    "tnc_container": {
      "label": "Most Important Terms & Conditions",
      "URL": "/en/eapply.page"
    }
  },
  pan_upload: {
    "uploading_pic": {
      "photoUploading": "Uploading {percentage}"
    },
    "instructions": {
      "maxMB": "Max size limit 5 MB",
      "clearPhoto": "Please ensure that the signature and photo are clear",
      "fileTypes": "File types: Jpeg, JPG, PNG, PDF"
    },
    "upload_pic": {
      "photoUpload": "Upload",
      "instruction": "(Drag and Drop or Browse)"
    },
    "uploaded_pic": {
      "reupload": "Re-upload"
    },
    "heading": "Dear {name}, Congratulations!",
    "tryAgain": "Try Again",
    "submitButtontext": "Submit PAN card copy",
    "editPrompt": "If we haven't got these details exactly right, please edit them",
    "information": "Your name is not matching with the PAN details, upload an image of PAN {pannumber}",
    "subheading": "You have successfully applied for {cardname} and you are just 1 step away",
    "reTry": "Retry",
    "mobile_icons": {
      "camera": "Camera",
      "gallery": "Gallery"
    },
    "errorContainer": {
      "errors": [
        {
          "msg": "Only Image files are allowed",
          "id": "onlyImg"
        },
        {
          "msg": "File size must be < 5MB",
          "id": "sixeExceed"
        }
      ]
    }
  },
  landing_page: {
    "landingPagetext": "Make your wishes come alive!"
  },
  saved_details_popup: {
    "heading": "Here is the summary of the information you provided us last time",
    "closeButton": "Close"
  },
  card_activated: {
    "cvv": "Click here for CVV",
    "heading": "Your card is ready for usage!",
    "subHeading": "Domestic Online and Mobile Tap & Pay transactions usage have been activated on your card",
    "footnoteMsg": "Your physical card will be delivered to your residence address within 5-7 days",
    "information": "You can now start using your virtual card for transactions",
    "okayButton": "Okay"
  },
  happy_to_help: {
    "text_list": [
      {
        "textItem": "PAN"
      },
      {
        "textItem": "Aadhaar number"
      },
      {
        "textItem": "Photograph"
      },
      {
        "textItem": "Bank Details"
      }
    ],
    "heading": "Happy to help!",
    "startButton": "Start apply journey",
    "steps_slider": {
      "step_2": {
        "heading": "Key professional details to know you better",
        "label": "STEP 2"
      },
      "step_1": {
        "heading": "Quick onboarding with basic personal details",
        "label": "STEP 1"
      },
      "cover_screen": {
        "heading": "Ready to use virtual card<br/> in just 3 easy steps"
      },
      "step_3": {
        "heading": "Secured KYC and bank verification to complete your application",
        "label": "STEP 3"
      }
    },
    "text": "While you proceed, we request you<br/> to keep following things handy:",
    "subheading": "A quick guide to your apply journey"
  },
  set_preferences: {
    "heading": "Activate card usage now!",
    "subHeading": "You can use your virtual card for domestic online and mobile tap n pay transactions",
    "domesticTapNpAY": "Domestic Mobile Tap n Pay Transactions",
    "domesticTapNpAYeg": "(SBI Card Pay, Samsung Pay)",
    "label": "Set Transactions Preferences",
    "domesticOnlineLabel": "Domestic online Transactions",
    "continueButton": "Continue"
  },
  close_journey_popup: {
    "exitButton": "Exit apply journey",
    "heading": "Dear {name}, this will pause your apply journey",
    "subheading": "We have saved your information and you can continue from where you left, by choosing \"Retrieve my application\"",
    "continueButton": "Continue to apply"
  },
  application_submitted: {
    "heading": "Dear {name}, thank you for your PAN Card",
    "footnoteMsg": "You can also track your application status using the application number on www.sbicard.com",
    "trackAppButton": "Track your application",
    "information": "We are now validating your application and will update you through SMS, post approval",
    "subheading": "Your application for {cardname} has been submitted successfully and your application number is {applicationnumber}"
  },
  professionalDetails: {
    "continueStep3Button": "Continue to step 3",
    "workAddress_container": {
      "pincode": {
        "text": "Pincode",
        "validation": {
          "validationType": "num",
          "minLength": 1,
          "maxLength": 6
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Should have 6 digits",
              "id": "lengthcheckfocus"
            },
            {
              "msg": "We do not provide services at your pin code",
              "id": "notexists"
            },
            {
              "msg": "Please enter valid Pin",
              "id": "specialChar"
            }
          ]
        }
      },
      "helpText": "",
      "city": {
        "text": "City",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": ""
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid city name",
              "id": "specialChar"
            }
          ]
        }
      },
      "addLine1": {
        "text": "Address Line 1",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": 40
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid Address Line 1",
              "id": "specialChar"
            }
          ]
        }
      },
      "label": "My workplace address is",
      "manualAddressConsent": "Others, I will enter it manually.",
      "addLine2": {
        "text": "Address Line2",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": 40
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid Address Line 2",
              "id": "specialChar"
            }
          ]
        }
      },
      "state": {
        "text": "State",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": ""
        },
        "errorContainer": ""
      },
      "landmark": {
        "text": "Landmark (If any)",
        "validation": {
          "validationType": "text",
          "minLength": 2,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid landmark",
              "id": "specialChar"
            }
          ]
        }
      },
      "headingLabel": "Your office address is"
    },
    "heading": {
      "subtext": "Your information is safe with us.",
      "text": "Help us with your professional details!"
    },
    "designation_container": {
      "helpText": "",
      "label": "My designation is",
      "text": "Designation",
      "validation": {
        "validationType": "text",
        "minLength": 1,
        "maxLength": 40
      },
      "headingLabel": "Your designation is",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Please enter valid Designation",
            "id": "specialChar"
          },
          {
            "msg": "Error saving details",
            "id": "updateFail"
          }
        ]
      }
    },
    "occupation_container": {
      "helpText": "",
      "label": "I am a",
      "text": "Occupation",
      "headingLabel": "You are a",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Please enter valid Occupation",
            "id": "specialChar"
          }
        ]
      }
    },
    "company_container": {
      "helpText": "",
      "label": "I work with",
      "text": "Company Name",
      "validation": {
        "validationType": "text",
        "minLength": 1,
        "maxLength": 30
      },
      "headingLabel": "You work with",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Invalid character in companyName",
            "id": "singleChar"
          },
          {
            "msg": "Please enter valid Company Name",
            "id": "specialChar"
          },
          {
            "msg": "Error saving details",
            "id": "updateFail"
          }
        ]
      }
    },
    "label": "02 Professional Details",
    "completionMsg": "You have now completed providing professional details"
  },
  header_container: {
    "exploreCard_container": {
      "label": "Explore More Cards",
      "URL": "/en/personal/credit-cards.page"
    },
    "help_container": {
      "label": "help",
      "URL": "/en/help.page"
    }
  },
  application_submission: {
    "card_generation": {
      "subHeading2": "Dear {name}, Congratulations!",
      "subHeading3": "you have successfully submitted your application for {cardname}",
      "subHeadingCardGenerated": "Your virtual {cardname} is generated successfully",
      "info_texts": {
        "cardGenerated": "E-card generated successfully",
        "professionalDetails": "Professional Details updated",
        "personalDetails": "Personal details updated",
        "bankVerification": "Bank Verification Completed",
        "kycDetails": "KYC Verification Successful"
      },
      "heading": "Dear {name}, your application is submitted",
      "applicationNumber": "Your application number is {applicationnumber}",
      "subHeadingSubmitted": "We are generating your virtual {cardname}",
      "process_delay": {
        "check_back": {
          "heading": "Dear {name}, your card generation is taking some time",
          "subHeading": "We would request you to check the status of e-card in 24-48 hrs. by clicking retreive application on",
          "okayButton": "Okay"
        },
        "retry": {
          "exitButton": "Exit apply journey",
          "heading": "Dear {name}, your card generation is taking some time",
          "subHeading": "We would request you to retry generating your card",
          "retryButton": "Retry now"
        }
      }
    },
    "otp_container": {
      "seconds": "Secs",
      "helpText": "",
      "heading": "Get your {cardname} now",
      "subHeading": "We have sent you a 6 digit OTP on your mobile number",
      "getCardButton": "Confirm OTP",
      "label": "Enter OTP",
      "resendOTPLabel": "Resend OTP",
      "errorContainer": {
        "errors": [
          {
            "msg": "Feild is mandatory",
            "id": "default"
          },
          {
            "msg": "You have exhausted the number of attempts for OTP Authentication. Please restart your application",
            "id": 105
          },
          {
            "msg": "You have exhausted the number of attempts for Resend OTP. Please restart your application.",
            "id": 106
          }
        ]
      }
    },
    "landing_screen": {
      "heading": "Submit your application",
      "tnc": "I agree to the above fees and <a href=\"#\">Terms &amp; Conditions</a>",
      "subheading": "Kindly review the details and get your card now",
      "card_info": {
        "renewal_fee": "Renewal Fee",
        "credit_limit": "Credit Limit",
        "annual_fee": "Annual Fee"
      },
      "continueButton": "Submit"
    },
    "application_successful": {
      "cvv": "Click here for CVV",
      "heading": "Dear {name}, Congratulations!",
      "subHeading": "Here's your virtual card!",
      "footnoteMsg": "Your physical card will be delivered to your residence address within 5-7 days",
      "information": "You can start using it for Online Transactions right away by activating Online Transactions usage on your card.",
      "setPreferencesButton": "Activate Card Usage"
    },
    "label": "Application Submission",
    "lhs_details": {
      "heading": "Almost there!"
    }
  },
  card_tile_page: {
    "step_tiles": {
      "personal_detail": {
        "heading": "01 Personal Details",
        "text": "Name, Mobile Number, City, PAN, DOB..."
      },
      "kyc_details": {
        "heading": "03 KYC Details",
        "text": "Address, Pin Code..."
      },
      "professional_detail": {
        "heading": "02 Professional Details",
        "text": "Occupation, Designation, Company Name..."
      }
    },
    "heading": "Follow these 3 simple steps",
    "subheading": "Starting with personal details"
  },
  download_app: {
    "download_links": {
      "appStore": "https://apps.apple.com/in/app/sbi-card/id694549848",
      "playStore": "https://play.google.com/store/apps/details?id=com.ge.capital.konysbiapp&hl=en"
    },
    "subHeading2": "Help us serve you better",
    "heading": "Download SBI Card mobile app for easy card account management",
    "subHeading": "Create account & earn <b>500 reward points</b>",
    "profile_completion": {
      "completionPercentage": "Your profile is <b>{profilepercentage}</b> complete",
      "updateProfile": "Update and get rewarded",
      "rewards": "You have earned <br/>500 reward points"
    },
    "services": {
      "tile": [
        {
          "image": "",
          "bgColor": "#2196F3",
          "heading": "Card Protection plan(CPP)",
          "subHeading": "Nam congue ex ante vitae, Phasellus finiblus leo",
          "URL": "https://india.cppdirect.com/sbi-card"
        },
        {
          "image": "",
          "bgColor": "#FFE7BC",
          "heading": "Add on card",
          "subHeading": "Nam congue ex ante vitae, Phasellus finiblus leo",
          "URL": "/creditcards/app/service/addon-page"
        },
        {
          "image": "",
          "bgColor": "#50BFA5",
          "heading": "Refer and Earn",
          "subHeading": "Nam congue ex ante vitae, Phasellus finiblus leo",
          "URL": "/creditcards/app/service/refernearn-page"
        }
      ]
    }
  },
  personalDetails: {
    "email_container": {
      "helpText": "",
      "label": "My email for communication is",
      "text": "Email ID",
      "card_type": "IRCP,CSC2,EGPU,EGSU",
      "validation": {
        "validationType": "email",
        "minLength": 1,
        "maxLength": 40
      },
      "headingLabel": "Your email for communication is",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Invalid E-mail",
            "id": "invalidEmail"
          }
        ]
      }
    },
    "edit": "Edit",
    "heading": {
      "subtext": "Help us with your name that matches your KYC documents for faster approval",
      "text": "Nice Meeting You!"
    },
    "label": "01 Personal Details",
    "submitButtontext": "Confirm OTP",
    "wrapper_container": {
      "heading": "Help us know you better!",
      "subHeading": "Your information is safe with us",
      "footnoteMsg": "If we haven't got these details right, please edit them",
      "confirmButtonText": "Confirm"
    },
    "ffn": {
      "helpText": "",
      "heading": "Since you have changed your card, help us with your frequent flyer number",
      "label": "My frequent flyer number",
      "text": "Number",
      "validation": {
        "validationType": "text",
        "minLength": "",
        "maxLength": ""
      },
      "errorContainer": {
        "errors": {
          "msg": "Field is mandatory",
          "id": "default"
        }
      }
    },
    "motherName_container": {
      "helpText": "",
      "label": "My mother's name is",
      "text": "Name",
      "validation": {
        "validationType": "text",
        "minLength": 1,
        "maxLength": 15
      },
      "headingLabel": "Your mother's name is",
      "errorContainer": {
        "errors": [
          {
            "msg": "Please provide your valid Mother’s Maiden Name",
            "id": "specialChar"
          },
          {
            "msg": "Field is mandatory",
            "id": "default"
          }
        ]
      }
    },
    "city_container": {
      "helpText": "You can edit your city",
      "heading": "Help us with your current residential city",
      "footnoteMsg": "If we haven't got it right, please edit it",
      "label": "My current city is",
      "text": "City Name",
      "headingLabel": "Your current city is",
      "errorContainer": {
        "errors": [
          {
            "msg": "Please select from list",
            "id": "default"
          },
          {
            "msg": "Please select from list",
            "id": "singleChar"
          },
          {
            "msg": "Please select from list",
            "id": "manualCity"
          },
          {
            "msg": "Please enter valid city name",
            "id": "specialChar"
          }
        ]
      },
      "confirmButtonText": "Confirm city"
    },
    "otp_container": {
      "seconds": "Secs",
      "helpText": "We have sent you an OTP on your mobile number",
      "heading": "We have sent you a 6 digit OTP on your mobile number",
      "label": "OTP received on my mobile",
      "resendOTPLabel": "Resend OTP",
      "errorContainer": {
        "errors": [
          {
            "msg": "Please enter valid OTP",
            "id": "default"
          },
          {
            "msg": "You have exhausted the number of attempts for OTP Authentication. Please restart your application",
            "id": 105
          },
          {
            "msg": "You have exhausted the number of attempts for Resend OTP. Please restart your application.",
            "id": 106
          }
        ]
      }
    },
    "mobile_container": {
      "helpText": "",
      "label": "My mobile number is",
      "text": "Mobile Number",
      "validation": {
        "validationType": "num",
        "minLength": 10,
        "maxLength": 10
      },
      "headingLabel": "We will call you at",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Should have 10 digits.Invalid phone no.",
            "id": "lessThan10digits"
          },
          {
            "msg": "Please enter a valid mobile no.",
            "id": "specialChar"
          },
          {
            "msg": "Please enter a valid mobile no.",
            "id": "startsWith"
          }
        ]
      }
    },
    "pan_container": {
      "helpText": "You can edit your PAN",
      "label": "My PAN is",
      "text": "",
      "validation": {
        "validationType": "pan",
        "minLength": 1,
        "maxLength": 10
      },
      "headingLabel": "Your PAN is",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Invalid PAN. Should have 10 digits.",
            "id": "invalidPan"
          },
          {
            "msg": "Invalid Pan Number",
            "id": "pan100"
          }
        ]
      }
    },
    "referral_code": {
      "helpText": "",
      "label": "Referral Code",
      "text": "",
      "validation": {
        "validationType": "text",
        "minLength": "",
        "maxLength": ""
      },
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "Please enter a valid referral code",
            "id": "specialChar"
          }
        ]
      }
    },
    "dob_container": {
      "helpText": "You can edit your DOB",
      "label": "I was born on",
      "text": "dd/mm/yyyy",
      "headingLabel": "You were born on",
      "errorContainer": {
        "errors": [
          {
            "msg": "Field is mandatory",
            "id": "default"
          },
          {
            "msg": "DOB invalid",
            "id": "specialChar"
          },
          {
            "msg": "Age should be above 18",
            "id": "agebelow18"
          },
          {
            "msg": "Please enter age between 18 & 99 years",
            "id": "agebeyond99"
          }
        ]
      }
    },
    "continueStep2Button": "Continue to step 2",
    "completionMsg": "You have now completed providing personal details",
    "name_container": {
      "firstName": {
        "label": "First Name",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": 12
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Only Alphabets allowed",
              "id": "specialChar"
            },
            {
              "msg": "Last name should not be same as First name",
              "id": "sameFirstLastName"
            }
          ]
        }
      },
      "lastName": {
        "label": "Last Name",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": 16
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Last Name should not be same as First Name.",
              "id": "sameFirstLastNameWithChar"
            },
            {
              "msg": "Only Alphabets allowed",
              "id": "specialChar"
            }
          ]
        }
      },
      "helpText": "",
      "middleName": {
        "label": "Middle Name",
        "validation": {
          "validationType": "text",
          "minLength": "",
          "maxLength": 10
        },
        "errorContainer": {
          "errors": {
            "msg": "Only Alphabets allowed",
            "id": "specialChar"
          }
        }
      },
      "label": "My name is",
      "headingLabel": "Nice meeting you!"
    },
    "consent_container": {
      "text": "I have read and accept the <a href=\"/sbi-card-en/assets/docs/pdf/customer_declaration.pdf\" target=\"_blank\" rel=\"noopener\">Terms and Conditions.</a>",
      "errorContainer": {
        "errors": {
          "msg": "Please click on consent box",
          "id": "default"
        }
      }
    }
  },
  multicard_eligibility: {
    "heading": "Dear {name},<br />you are our esteemed customer",
    "footnoteMsg": "Choose now from our different card offers",
    "text": "You can get an instant virtual card...No process required!",
    "continueButton": "Continue"
  },
  globalconfig_container: {
    "serviceTimeOut": 10000,
    "resendOtpTimer": 30,
    "digiLockerTimeout": 10000,
    "otpResendAttempts": 5,
    "otpAuthAttemts": 5,
    "max_pan_pdf_upload_size": 1024
  },
  kycDetails: {
    "final_address_confirmation": {
      "reference_text": {
        "referenceTextDigiLocker": "(Select address from DigiLocker for instant card)",
        "referenceSuggestedAddress": "(Select address to get card after verification)",
        "referenceTextManual": "(Select manual address to get card after verification)"
      },
      "heading": "Confirm your address one last time, as we have fetched it from DigiLocker",
      "label": "My current address is",
      "confirmation": "You have now completed providing residential details",
      "footnote": "Your card will be delivered to the selected address, post approval",
      "continueButtonText": "Continue & confirm"
    },
    "photo_kyc": {
      "continue_upload": {
        "heading": "Awesome, that's a great click!",
        "subheading": "Continue if you are happy with this image",
        "continueButton": "I like it"
      },
      "blurry_photo": {
        "heading": "Oops!",
        "subheading": "Looks like your photo is blurry, kindly retake",
        "continueButton": "I like it"
      },
      "icons": {
        "camera": "Camera",
        "browse": "Browse photo"
      },
      "photo_upload": {
        "openCamera": "Open camera",
        "heading": "Let's take your photo",
        "subheading": "We will verify it with your KYC document",
        "browse": "Browse photo"
      },
      "mobile_options": {
        "retakeSelfie": "Retake selfie",
        "takeSelfie": "Take a selfie",
        "capture": "Capture",
        "clickNow": "Click now",
        "gallery": "Gallery"
      }
    },
    "KYC_ressidential_address": {
      "helpText": "",
      "heading": "Kindly confirm your current residential address",
      "subHeading": "We have fetched your address from your KYC documents, to save you some time",
      "footnoteMsg": "Your card will be delivered to the selected address, post approval",
      "digilockerVfyLabel": "I have another address",
      "label": "My current address is",
      "continueButton": "Confirm & continue"
    },
    "manual_address_entry_container": {
      "pincode": {
        "text": "Pincode",
        "validation": {
          "validationType": "num",
          "minLength": 1,
          "maxLength": 6
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Should have 6 digits",
              "id": "lengthcheckfocus"
            },
            {
              "msg": "We do not provide services at your pin code",
              "id": "notexists"
            },
            {
              "msg": "Please enter valid Pin",
              "id": "specialChar"
            }
          ]
        }
      },
      "helpText": "",
      "heading": "Kindly provide your address",
      "city": {
        "text": "City",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": ""
        },
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "locality": {
        "text": "Locality",
        "validation": {
          "validationType": "text",
          "minLength": 2,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid locality",
              "id": "specialChar"
            }
          ]
        }
      },
      "house_number": {
        "text": "House No",
        "validation": {
          "validationType": "text",
          "minLength": 2,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid House No",
              "id": "specialChar"
            }
          ]
        }
      },
      "label": "My current address is",
      "continueButtonText": "Continue",
      "subHeading": "Your card will be delivered to the below address, post approval",
      "footnoteMsg": "Our executive will visit the above mentioned address for verification",
      "addLine2": {
        "text": "Address Line2",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": 40
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Field is mandatory",
              "id": "default"
            },
            {
              "msg": "Please enter valid Address Line 2",
              "id": "specialChar"
            }
          ]
        }
      },
      "state": {
        "text": "State",
        "validation": {
          "validationType": "text",
          "minLength": 1,
          "maxLength": ""
        },
        "errorContainer": ""
      },
      "landmark": {
        "text": "Landmark (If any)",
        "validation": {
          "validationType": "text",
          "minLength": "",
          "maxLength": 20
        },
        "errorContainer": {
          "errors": [
            {
              "msg": "Please enter valid landmark",
              "id": "specialChar"
            },
            {
              "msg": "Field is mandatory",
              "id": "default"
            }
          ]
        }
      }
    },
    "gender_kyc_container": {
      "gender_options": {
        "gender_option_text": [
          {
            "gender_text": "Male",
            "gender_id": "male"
          },
          {
            "gender_text": "Female",
            "gender_id": "female"
          }
        ]
      },
      "heading": "Kindly help us know you better",
      "label": "I identify my gender as",
      "confirmButtonText": "Confirm"
    },
    "virtualcard_downsell": {
      "heading": "We have other cards based on your spending limit",
      "subheading": "Select a card which suits your requirement",
      "continueButton": "Select card & continue"
    },
    "card_eligibility_container": {
      "subheading_kyccomplete": "You are now eligible for this card.",
      "heading": "Congratulations, {name}!",
      "footnoteMsg": "Complete KYC verification to get your card.",
      "subheading_executivevfy": "You are eligible for the card now.<br />Once our executive verifies your address, your card will be activated",
      "continueButtonText": "Continue"
    },
    "label": "03 KYC Details",
    "digilocker_container": {
      "aadhaar_otp_container": {
        "aadhaar_container": {
          "helpText": "",
          "heading": "SBI Card",
          "subHeading": "You are about to link your DigiLocker Account. You will be signed up, if it does not exist.",
          "label": "Enter your Aadhaar number to continue with DigiLocker",
          "continueButtonText": "Continue",
          "errorContainer": {
            "errors": {
              "msg": "Field is mandatory",
              "id": "default"
            }
          }
        },
        "otp_container": {
          "seconds": "Secs",
          "helpText": "",
          "heading": "Sign Up",
          "subHeading": "UIDAI has sent you a 6 digit OTP on your mobile number ending with {number}",
          "label": "OTP received on my mobile",
          "resendOTPLabel": "Resend OTP",
          "errorContainer": {
            "errors": [
              {
                "msg": "Please enter valid OTP",
                "id": "default"
              },
              {
                "msg": "You have exhausted the number of attempts for OTP Authentication. Please restart your application",
                "id": 105
              },
              {
                "msg": "You have exhausted the number of attempts for Resend OTP. Please restart your application.",
                "id": 106
              }
            ]
          },
          "confirmButtonText": "Confirm OTP"
        },
        "heading": "Verify your current residential address with DigiLocker",
        "digilocker_consent_container": {
          "helpText": "",
          "heading": "SBI Card",
          "subHeading": "We would like to access your DigiLocker to:",
          "allowButtonText": "Allow",
          "denyButtonText": "Deny",
          "consent_list": {
            "docsConsentLabel": "Get the list of issued documents",
            "eAadhaarConsentLabel": "Get your e-Aadhaar data"
          },
          "allowConsent": "By clicking allow, you provide consent to allow this application to access your DigiLocker"
        },
        "backText": "Back to address list"
      },
      "process_timeout_container": {
        "heading": "Process timeout",
        "subHeading": "We are unable to fetch your current residential address, kindly help us by entering manually",
        "continueButtonText": "Continue"
      },
      "aadhaar_disclaimer": {
        "agreementText": "By clicking the below button, I agree that I have read the<a href=\"#\"> Aadhaar user consent document</a> and voluntarily consent to share my Aadhaar information (excluding the Aadhaar number) with SBI Card for applying credit card Swift application online.",
        "helpText": "",
        "heading": "DigiLocker for instant KYC verification",
        "consentText": "Share your address-related information from DigiLocker account fir KYC. Your Aadhaar number is neither visible nor available with us and hence not stored.<br /><br />Digilocker is government of India portal, which provides access to authentic digital documents to citizen's digital document wallet <a href=\"https://www.digilocker.gov.in/dashboard\">know more.</a>",
        "continueButton": "Continue to DigiLocker"
      },
      "digilocker_access_denied": {
        "additional_confirmation": {
          "heading": "DigiLocker for instant KYC verification",
          "label": "I will provide my current address by:",
          "consent": "By clicking the below button, I agree that I have read the<a href=\"#\"> Aadhaar user consent document</a> and voluntarily consent to share my Aadhaar information (excluding the Aadhaar number) with SBI Card for applying credit card Swift application online.",
          "subheading": "DigiLocker is completely safe and secure to use. It takes care about your privacy and ensures that your data is protected.",
          "continueButtonText": "Continue",
          "address_options": {
            "manual_option": {
              "referenceText": "(Select manual address to get card after verification)",
              "optionText": "Entering it manually"
            },
            "digilocker_option": {
              "referenceText": "(Select address from DigiLocker for instant card)",
              "optionText": "Going ahead with DigiLocker"
            }
          }
        },
        "access_denied_popup": {
          "heading": "DigiLocker access denied",
          "subHeading": "Kindly help us with your current residential address as we are unable to fetch it from DigiLocker",
          "continueButtonText": "Continue"
        }
      },
      "digilocker_allow": {
        "address_confirmation_digiLocker": {
          "manualEntryOption": "I will enter it manually",
          "helpText": "",
          "footnote_messages": {
            "footnoteDigiLocker": "Your card will be delivered to the selected address, post approval",
            "footnoteManual": "Our executive will vivit your residential address for verification"
          },
          "heading": "Kindly confirm your current residential address",
          "confirmAndContinueButtonText": "Confirm and continue",
          "label": "My current address is"
        },
        "digilocker_success": {
          "mainText": "Success",
          "subText": "We have obtained your documents from DigiLocker"
        }
      }
    },
    "final_eCard_look": {
      "heading": "Dear {name},<br />Thank you for applying SBI Card",
      "footnoteMsg": "You will receive this card post verification and approval",
      "okayButton": "Okay",
      "subheading": "Our executive will connect with you shortly"
    }
  },
  additional_content: {
    "workAddress_container": {
      "pincode": {
        "text": "Pincode",
        "validation": {
          "validationType": "text",
          "minLength": 3,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "helpText": "",
      "city": {
        "text": "City",
        "validation": {
          "validationType": "text",
          "minLength": 3,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "addLine1": {
        "text": "Address Line1",
        "validation": {
          "validationType": "text",
          "minLength": 3,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": {
            "msg": "Field is mandatory",
            "id": "default"
          }
        }
      },
      "label": "My workplace address is",
      "addLine2": {
        "text": "Address Line 2",
        "validation": {
          "validationType": "text",
          "minLength": 3,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": {
            "msg": "Feild is mandatory",
            "id": "default"
          }
        }
      },
      "state": {
        "text": "State",
        "validation": {
          "validationType": "text",
          "minLength": 3,
          "maxLength": 20
        },
        "errorContainer": {
          "errors": {
            "msg": "Feild is mandatory",
            "id": "default"
          }
        }
      }
    },
    "heading": "Help us with additional details and earn reward points",
    "label": "Additional Details",
    "fatherName_container": {
      "helpText": "",
      "label": "My father's name is",
      "text": "Name",
      "validation": {
        "validationType": "text, num",
        "minLength": 3,
        "maxLength": 20
      },
      "errorContainer": {
        "errors": {
          "msg": "Field is mandatory",
          "id": "default"
        }
      }
    },
    "submitButtontext": "Submit details"
  }


};

export default content;
